<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let userType = "";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div
	class:owner={userType === 'STOREOWNER'}
	class:user={userType === 'USER'}
	class="badge">
	{#if userType === 'STOREOWNER'}STORE OWNER{:else}{userType}{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.badge {
		width: max-content;
		padding: 6px 15px;
		font-size: 0.875rem;
		font-weight: 500;
		border-radius: 20px;
		color: white;

		&.owner {
			background-color: #6591fa;
		}

		&.user {
			background-color: #6d6f76;
		}
	}
	@include DesktopSize {
		.badge {
			font-size: 1rem;
		}
	}

</style>
